import { Avatar, Box, Stack, Typography } from "@mui/material";
import { ConversationMessage, datetimeSimplifier, timeSimplifier } from "../../../redux/conversation/conversationSlice";
import { MessageContent } from "./MessageContent";
import { stringAvatar, stringToColor } from "../../user/avatarUtils";
import { useEffect, useMemo, useState } from "react";
import { NamedObject } from "../../../redux/object/namedObject";
import { ObjectRetrieveRequest, retrieveObject, selectObjectCache } from "../../../redux/object/objectCacheSlice";
import { ObjectTarget } from "../../../app/permissions";
import { useSelector } from "react-redux";
import { assertThumbnailUrl, LoadState } from "../../../redux/common";
import { useAppDispatch } from "../../../app/hooks";

export interface MessageTileMyselfProps {
    message: ConversationMessage;
    content?: React.ReactNode;
}

export const MessageTileMyself = (props: MessageTileMyselfProps) => {
    const msg = props.message;
    // const image = "abc";
    // const name = msg.partyId;
    const dt = timeSimplifier(msg.processed);
    const [editUser, setEditUser] = useState(undefined as undefined | NamedObject);
    const objectCache = useSelector(selectObjectCache);
    const dispatch = useAppDispatch();
    const edited = msg.edited ? `Editado ${datetimeSimplifier(msg.edited)}` : "";

    const reqEditUser = useMemo((): ObjectRetrieveRequest => {
        return {
            objectTarget: ObjectTarget.USER,
            targetId: `${msg.editUserId}`,
        };
    }, [msg.editUserId]);
    useEffect(() => {
        if (!msg.editUserId) {
            return;
        }
        const foundObject = (objectCache.cache.users[reqEditUser.targetId]);
        if (foundObject) {
            setEditUser(NamedObject.user(foundObject));
        }
        if (!foundObject) {
            let state = LoadState.NotStarted;
            if (objectCache.requests[reqEditUser.objectTarget + ":" + reqEditUser.targetId]
                && objectCache.requests[reqEditUser.objectTarget + ":" + reqEditUser.targetId].state) {
                state = objectCache.requests[reqEditUser.objectTarget + ":" + reqEditUser.targetId].state;
            }
            if (state == LoadState.NotStarted) {
                dispatch(retrieveObject(reqEditUser));
            }
        }
    }, [reqEditUser, objectCache]);

    let editImage = undefined;
    let editName = "-";
    if (editUser) {
        editImage = assertThumbnailUrl(editUser.url);
        editName = editUser.display;
    } else if (msg.editUserId) {
        editName = `${msg.editUserId}`;
        editImage = "";
    }

    const message = <MessageContent message={msg} content={props.content} align="right" />;

    return <Box sx={{ marginLeft: 16, marginY: 1 }}>
        <Stack direction="column">
            <Stack direction="row" spacing={1}>
                <Box sx={{ flexGrow: 1 }} />
                <Box key={dt}
                    sx={{ padding: 1, borderRadius: 2, border: "1px black solid", backgroundColor: "#ccFFCC", minWidth: 300 }}>
                    <Stack direction="column" spacing={0}>
                        <Typography variant="body2" component="span" color='black' textAlign={"right"} sx={{ overflowWrap: "anywhere" }}>
                            {message}
                        </Typography>
                        <Typography variant="caption" component="span" fontSize={9} sx={{ textAlign: "right", color: "#555", marginY: "-2px" }}>
                            {dt}
                        </Typography>
                    </Stack>
                </Box>
            </Stack>
            {edited &&
                <Stack direction="column" alignItems="right" sx={{ marginLeft: 1, marginTop: "0px", marginBottom: "3px" }}>
                    <Typography variant="caption" component="span" fontSize={10} sx={{ textAlign: "right", color: "#555", marginY: "-2px" }}>
                        {edited}
                    </Typography>
                    <Stack direction="row" spacing={1} justifyContent="flex-end" alignItems="center">
                        <Avatar sx={{ width: 16, height: 16, m: 0, border: "1px solid gray", backgroundColor: stringToColor(editName) }}
                            variant='circular' alt={`${editName}`} src={`${editImage}`}>
                            <Typography variant="h6" component="span" fontSize={9}>
                                {stringAvatar(editName)}
                            </Typography>
                        </Avatar>
                        <Typography variant="caption" component="span" fontSize={10} sx={{ textAlign: "right", color: "#555" }}>
                            {editName}
                        </Typography>
                    </Stack>
                </Stack>
            }
        </Stack>
    </Box>;
};

